import { db } from '../firebase';
import { collection, doc, addDoc, getDocs, query, updateDoc, deleteDoc, where } from 'firebase/firestore';

export interface Staff {
  id?: string;
  tenantId: string;
  name: string;
  email: string;
  posId: string;
  payrollId?: string;
  role: string;
  businessType: string;
  locationId?: string;
  locationName?: string;
  assignedLocationIds?: string[];
}

export const getStaff = async (tenantId: string): Promise<Staff[]> => {
  const staffRef = collection(db, 'tenants', tenantId, 'staff');
  const q = query(staffRef);
  try {
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as Staff));
  } catch (error) {
    console.error('Error fetching staff:', error);
    return [];
  }
};

export const getStaffByEmail = async (tenantId: string, email: string): Promise<Staff | null> => {
  const staffList = await getStaff(tenantId);
  return staffList.find(s => s.email.toLowerCase() === email.toLowerCase()) || null;
};

export const addStaff = async (tenantId: string, staff: Staff) => {
  // Enforce that the staff member is linked to the correct tenantId and explicit location
  const effectiveLocationId = staff.locationId && staff.locationId !== 'all' ? staff.locationId : 'loc-downtown';
  const effectiveLocationName = staff.locationName || (effectiveLocationId === 'loc-downtown' ? 'Downtown Bistro' : 'Store Location');
  const assignedLocationIds = staff.assignedLocationIds && staff.assignedLocationIds.length > 0 
    ? staff.assignedLocationIds 
    : [effectiveLocationId];

  const staffData = { 
    ...staff, 
    tenantId,
    locationId: effectiveLocationId,
    locationName: effectiveLocationName,
    assignedLocationIds
  };
  const staffRef = collection(db, 'tenants', tenantId, 'staff');
  await addDoc(staffRef, staffData);
};

export const updateStaff = async (tenantId: string, staffId: string, staff: Partial<Staff>) => {
  // Ensure we are updating a staff member that belongs to this tenantId
  const staffRef = doc(db, 'tenants', tenantId, 'staff', staffId);
  await updateDoc(staffRef, staff);
};

export const deleteStaff = async (tenantId: string, staffId: string) => {
  const staffRef = doc(db, 'tenants', tenantId, 'staff', staffId);
  await deleteDoc(staffRef);
};
